/**
 * 个股实时行情 UI 状态与服务端 market tips 协议常量。
 * @module constants/stockRealtimeStatus
 */

/** 组件侧展示用的实时行情状态 */
export const STOCK_REAL_TIME_STATUS = Object.freeze({
  /** 未展示提示 */
  NONE: 'none',
  /** 行情连接中（对应 RealtimeHub CONNECTING） */
  QUOTE_CONNECTING: 'quote_connecting',
  /** 非交易日 */
  NON_TRADING_DAY: 'non_trading_day',
  /** 海外休市延迟 */
  OVERSEAS_HOLIDAY: 'overseas_holiday'
});

/**
 * 服务端 `stock_market_tips` 推送的 `data.status` 取值。
 * @readonly
 */
export const STOCK_MARKET_TIP_STATUS = Object.freeze({
  /** 断线 */
  DISCONNECTED: 1,
  /** 非交易日 */
  NON_TRADING_DAY: 2,
  /** 海外休市延迟 */
  OVERSEAS_HOLIDAY: 3
});

/** WebSocket 业务 topic：`businessType` / 订阅 topic */
export const WS_STOCK_MARKET_TIPS = 'stock_market_tips';

/**
 * 将服务端 market tip 状态码映射为 `STOCK_REAL_TIME_STATUS`。
 * @param {unknown} tipStatus 服务端 `data.status`
 * @returns {typeof STOCK_REAL_TIME_STATUS[keyof typeof STOCK_REAL_TIME_STATUS]}
 */
export function mapMarketTipStatusToRealtimeStatus(tipStatus) {
  const code = Number(tipStatus);
  switch (code) {
    case STOCK_MARKET_TIP_STATUS.NON_TRADING_DAY:
      return STOCK_REAL_TIME_STATUS.NON_TRADING_DAY;
    case STOCK_MARKET_TIP_STATUS.OVERSEAS_HOLIDAY:
      return STOCK_REAL_TIME_STATUS.OVERSEAS_HOLIDAY;
    case STOCK_MARKET_TIP_STATUS.DISCONNECTED:
    default:
      return STOCK_REAL_TIME_STATUS.NONE;
  }
}
